// extracted by mini-css-extract-plugin
module.exports = {"bg":"free-mail-offer-card_bg__2qzjU"};